import { TableEmployeeSurveysComponent } from '../../components/table-employee-surveys/table-employee-surveys.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
	standalone: true,
	selector: 'card-employee-surveys',
	templateUrl: './card-employee-surveys.component.html',
	imports: [ CommonModule, TableEmployeeSurveysComponent, ListPagerComponent, FormsModule ]
})
export class CardEmployeeSurveysComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() questionnaireCode: any | undefined;
	@Input() pulseContext: any | undefined;

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.employees = [];
		this.vm.pageSize = 10;
		this.vm.questionnaireCode = this.questionnaireCode;
		this.vm.pulseContext = this.pulseContext;
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}
